import React from 'react'

export function getParsedUser() {
    const data = localStorage.getItem('prescriptionUser')
    return !data ? null : JSON.parse(data)
}

export function clearUser() {
    localStorage.removeItem('prescriptionUser')
}

export function useLoggedUser(props) {
    const [user] = React.useState(getParsedUser())

    React.useEffect(() => {
        if (!user && props?.history) {
            props.history.push('/')
        }
    }, [user, props?.history])

    return user
}
